import { PLACEHOLDER_ITEMS } from './LineItems-constants';

const ContainerComponent = ({ children, job, isLoading }) => {
  const lineItems = isLoading
    ? PLACEHOLDER_ITEMS
    : job?.job_items.map((item, index) => ({
        ...item,
        key: `item-${index}`,
      })) || [];

  return children({
    lineItems,
  });
};

ContainerComponent.displayName = 'JobSidebar-LineItems-container';

export default ContainerComponent;
